import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/13_card_back_happy_cartoon_dog/13_card_back_happy_cartoon_dog"
 * Contains 1 texture(s)
 */
export class CardsBacks13CardBackHappyCartoonDogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/13_card_back_happy_cartoon_dog/13_card_back_happy_cartoon_dog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '13_happy_cartoon_dog.png'
    ] as const;
}
